"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var SvgBricksOutline = function (props) { return (react_1.default.createElement("svg", __assign({ width: '1em', height: '1em', viewBox: '0 0 24 24' }, props),
    react_1.default.createElement("path", { fillRule: 'evenodd', clipRule: 'evenodd', d: 'M7.004 2H11c1.333 0 2 .667 2 2v2c0 1.333-.667 2-2 2H7c-1.333 0-2-.667-2-2V4c0-1.333.668-2 2.004-2zM7 4v2h4V4H7zm4.004 5H15c1.333 0 2 .667 2 2v2c0 1.333-.667 2-2 2h-4c-1.333 0-2-.667-2-2v-2c0-1.333.668-2 2.004-2zM11 11v2h4v-2h-4zm-3.996 5H11c1.333 0 2 .667 2 2v2c0 1.333-.667 2-2 2H7c-1.333 0-2-.667-2-2v-2c0-1.333.668-2 2.004-2zM7 18v2h4v-2H7zm9.004-2H20c1.333 0 2 .667 2 2v2c0 1.333-.667 2-2 2h-4c-1.333 0-2-.667-2-2v-2c0-1.333.668-2 2.004-2zM16 18v2h4v-2h-4zM2 2c1.333.07 2 .737 2 2v2c0 1.333-.667 2-2 2V2zm0 14c1.333.07 2 .737 2 2v2c0 1.333-.667 2-2 2v-6zm.001-3H6v-2H2.003l.001-2H6c1.333 0 2 .667 2 2v2c0 1.333-.667 2-2 2H2l.001-2z' }))); };
exports.default = SvgBricksOutline;
//# sourceMappingURL=BricksOutline.js.map